import React from 'react';
import { AccountEntity } from '@interpals/api-web';
import clsx from 'clsx';

import Icon from 'components/Icon';
import UserAvatar from 'components/UserAvatar';

import css from 'components/Header/Header.module.scss';

interface Props {
    account: AccountEntity;
}

const AccountMenuButton: React.FC<Props> = ({ account }) => {
    return (
        <div className={css.flexWrapper}>
            <div className={clsx(css.headerButton, css.marginMenu)}>
                <UserAvatar user={account} size="XS" withFlag={false} />
                <Icon name="arrow-down-thick" color="white" width={18} />
            </div>
        </div>
    );
};

export default AccountMenuButton;
